import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import TextField from '@material-ui/core/TextField';
import ActionButton from "components/ActionButton";
import { convertToNumericMonthAndDayAndYear } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import toast, { Toaster } from 'react-hot-toast';
import AccountBanner from "../../components/AccountBanner"

const { DateTime } = require("luxon");

class BrandCreatorActivity extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: this.getDateFromPropsOrDefault("startDate").startOf("day"),
            endDate: this.getDateFromPropsOrDefault("endDate").endOf("day"),
            minDate: "1753-01-01",
            maxDate: "9999-12-31",
            creators: [],
            creatorLinks: [],
            partners: [],
            value: [],
            creatorsLoading: false,
            merchantError: true,
            creatorLinksLoading: false,
            selected: this.props.location?.state?.["merchantName"] && this.props.location.state["merchantId"]
                ? [{ name: this.props.location.state["merchantName"], id: parseInt(this.props.location.state["merchantId"], 10) }]
                : [],
            options: this.props.location?.state?.["merchantName"] && this.props.location.state["merchantId"]
                ? [{ name: this.props.location.state["merchantName"], id: parseInt(this.props.location.state["merchantId"], 10) }]
                : [],
            loading: false,
            BrandCreatorTable: {
                title: "Brand Creators",
                columns: [
                    {
                        name: "userId",
                        label: "UserId",
                        options: {
                            filter: true,
                            sort: true,
                            display: false
                        },
                    },
                    {
                        name: "userName",
                        label: "UserName",
                        options: {
                            filter: true,
                            sort: true,
                        },
                    },
                    {
                        name: "email",
                        label: "Email",
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRender: (value) => {
                                return <a href={"mailto:" + value} className="brandOrange" style={{ width: "300px" }}>{value}</a>
                            },
                        },
                    },
                    {
                        name: "clickCount",
                        label: "Clicks on Brand Links for Selected Dates",
                        options: {
                            filter: true,
                            sort: true
                        },
                    },
                ],
                options: {
                    sortOrder: {
                        name: 'userName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
            BrandCreatorLinkTable: {
                title: "Brand Creator Links created OR with clicks for selected dates",
                columns: [
                    {
                        name: "createdDate",
                        label: "Date",
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRender: (value) => {
                                return convertToNumericMonthAndDayAndYear(value, false).replace(',', '');
                            }
                        }
                    },
                    {
                        name: "userName",
                        label: "UserName",
                        options: {
                            filter: true,
                            sort: true,
                        },
                    },
                    {
                        name: "rockporchLink",
                        label: "Link",
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRender: (value) => {
                                return <a href={value} className="brandOrange" target="_blank" rel="noreferrer" style={{ width: "300px" }}>{value}</a>
                            },
                        },
                    },
                    {
                        name: "clickCount",
                        label: "Clicks for Selected Dates",
                        options: {
                            filter: true,
                            sort: true,
                        },
                    },
                ],
                options: {
                    sortOrder: {
                        name: 'createdDate',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    breadCrumbList = [{ link: '/Admin', text: 'Admin' }, { link: '/Admin/CreatorClicks', text: 'Creator Clicks', active: true }];

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        if (this.props.history) {
            this.props.history.replace({
                ...this.props.location,
                state: {}
            });
        }
        if (this.state.selected?.length > 0) {
            this.getCreators();
            this.getCreatorLinks();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { startDate, endDate, selected} = this.state;

        if (
            prevState.selected !== selected ||
            prevState.startDate !== startDate ||
            prevState.endDate !== endDate
        ) {
            if (!!(this.state.selected?.[0]?.id)) {
                this.getCreators();
                this.getCreatorLinks();
            }
        }
    }

    getDateFromPropsOrDefault = (key) => {
        const dateFromProps = this.props[key]
            ? DateTime.fromISO(this.props[key]) // Handles direct Luxon objects or ISO strings
            : this.props.location?.state?.[key]
                ? DateTime.fromISO(this.props.location.state[key]) // Handles passed state from history.push
                : null;

        return dateFromProps?.isValid ? dateFromProps : DateTime.utc(); // Fallback to UTC if invalid
    };

    handleStartDateChange = (event) => {
        const startDateRaw = event.target.value;
        if (startDateRaw.length === 0) return;

        const startDate = DateTime.fromISO(startDateRaw).toUTC().startOf('day');
        if (startDate.isValid) {
            this.setState({ startDate });
        } else {
            console.error("Invalid start date entered:", startDateRaw);
        }
    };

    handleEndDateChange = (event) => {
        const endDateRaw = event.target.value;
        if (endDateRaw.length === 0) return;

        const endDate = DateTime.fromISO(endDateRaw).toUTC().startOf('day');
        if (endDate.isValid) {
            this.setState({ endDate });
        } else {
            console.error("Invalid end date entered:", endDateRaw);
        }
    };

    handleWeekToDate = () => {
        const startDate = DateTime.utc().minus({ weeks: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().startOf('day') });
    };

    handleMonthToDate = () => {
        const startDate = DateTime.utc().minus({ months: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().startOf('day') });
    };

    handleYearToDate = () => {
        const startDate = DateTime.utc().minus({ years: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().startOf('day') });
    };

    getCreators = async () => {
        const { startDate, endDate, showResolved } = this.state;

        let url = `api/Merchant/GetCreatorsWithLinksByMerchant?merchantId=` + this.state.selected[0].id;

        let now = DateTime.now();
        let offset = now.offset;

        if (startDate) {
            url += `&startDate=${startDate.toSQL({ includeOffset: false })}`
        }

        if (endDate) {
            url += url.includes('?') ? `&endDate=${endDate.plus({ days: 1 }).startOf('day').toSQL({ includeOffset: false })}` : `?endDate=${endDate.plus({ days: 1 }).startOf('day').toSQL({ includeOffset: false })}`;
        }

        url += `&offset=${offset}`

        this.setState({ creatorsLoading: true });
        const creators = await getRequest(url);
        this.setState({ creators, creatorsLoading: false });
    };    

    getCreatorLinks = async () => {
        const { startDate, endDate, showResolved } = this.state;

        let url = `api/Merchant/GetCreatorLinksByMerchant?merchantId=` + this.state.selected[0].id;

        let now = DateTime.now();
        let offset = now.offset;

        if (startDate) {
            url += `&startDate=${startDate.toSQL({ includeOffset: false })}`
        }

        if (endDate) {
            url += url.includes('?') ? `&endDate=${endDate.plus({ days: 1 }).startOf('day').toSQL({ includeOffset: false })}` : `?endDate=${endDate.plus({ days: 1 }).startOf('day').toSQL({ includeOffset: false })}`;
        }

        url += `&offset=${offset}`

        this.setState({ creatorLinksLoading: true });
        const creatorLinks = await getRequest(url);

        const creatorLinksWithSubdomain = this.getRockporchLinks(creatorLinks);
        this.setState({ creatorLinks: creatorLinksWithSubdomain, creatorLinksLoading: false });
    };   

    getRockporchLinks = clicks => {
        const shareSubdomain = this.state.selected[0].shareSubdomain ?? null

        return clicks.map(click => {
            let rockporchLink = "";
            let baseUrl = `${window.location.origin}`;

            if (shareSubdomain) {
                const url = new URL(baseUrl);

                if (url.host.startsWith("www.")) {
                    // Replace 'www.' with the shareSubdomain
                    url.host = url.host.replace("www.", `${shareSubdomain}.`);
                }

                baseUrl = url.toString().replace(/\/$/, ""); // Remove trailing slash
            }

            if (click.type === "Product") {
                rockporchLink = `${baseUrl}/prdlink/${click.shareCode}`;
            } else if (click.type === "Merchant") {
                rockporchLink = `${baseUrl}/mlink/${click.merchantId}?userId=${click.userId}`;
                if (click.referralLink && click.referralLink.length > 0) {
                    rockporchLink += `&redirectUrl=${encodeURIComponent(click.referralLink)}`;
                }
            }

            return { ...click, rockporchLink };
        });
    }

    setSelected = (selected) => {
        if (selected != null) {
            this.setState({ selected });
        }
    };

    fetchMerchants = async (query) => {
        this.setState({ loading: true });
        const options = await getRequest(`/api/Merchant/MerchantSearchByMerchantName?merchantName=${query}`);
        this.setState({ options, loading: false });
    };

    render() {
        return (
            <>
                <Toaster />

                <section>
                    <AccountBanner breadCrumbList={this.breadCrumbList}>
                        <h1 className="mb-4">Brand Creator Activity</h1>
                        <p className="mb-0">Find Creators and Creator Links associated with a particular brand</p>
                    </AccountBanner>
                </section>
                <div>

                    <section className="gray-bg mb-0 pt-2">
                        <div className="container pt-0 pb-0">
                            <div className="search-interest py-1 mx-auto">
                                <div className="search-block d-md-flex justify-content-between">
                                    <div>
                                        {
                                            this.props.location?.state?.merchantName?.length > 0 ?
                                                <></>
                                                :
                                                <AsyncTypeahead
                                                    id="merchantSearch"
                                                    labelKey="name"
                                                    selected={this.state.selected}
                                                    clearButton
                                                    onSearch={this.fetchMerchants}
                                                    onChange={e => this.setSelected(e)}
                                                    isLoading={this.state.loading}
                                                    options={this.state.options}
                                                    placeholder="Search for merchants..." />
                                        }  

                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="gray-bg mb-0 pt-2">
                        {
                            !["sm"].includes(this.props.deviceSize) ?
                                <></>
                                :
                                <div className="d-flex w-100 justify-content-end pr-2" style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                    <div onClick={this.handleWeekToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '4px 0 0 4px' }}>1w</div>
                                    <div onClick={this.handleMonthToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', borderTop: '1px solid lightgray', borderBottom: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>1m</div>
                                    <div onClick={this.handleYearToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '0 4px 4px 0' }}>1y</div>
                                </div>
                        }
                        <div className="container pt-0 pb-0">

                            <div className={`mx-0 d-flex justify-content-between pb-4 ${["sm"].includes(this.props.deviceSize) ? "ml-2 mr-2" : "pt-4"} mx-auto`}>

                                <div className={`d-flex ${["sm"].includes(this.props.deviceSize) ? "w-100 pt-3 mx-2" : ""} justify-content-${["sm"].includes(this.props.deviceSize) ? "between" : "start"}`} style={{ gap: ["sm"].includes(this.props.deviceSize) ? "" : "30px", fontFamily: "'Urbanist',sans-serif" }}>
                                    <p className="ml-3 pt-3 mb-0" style={{ color: "red", display: this.state.dateError ? "" : "none" }}>Start Date must be before the End Date</p>

                                    <div className="d-flex flex-column">
                                        <label className="mb-0">Start Date:</label>
                                        <TextField
                                            id="start-date"
                                            type="date"
                                            value={this.state.startDate.toISODate()}
                                            onChange={this.handleStartDateChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                style: { fontFamily: "'Urbanist', sans-serif" },
                                            }} />
                                    </div>
                                    <div className="d-flex flex-column">
                                        <label className="mb-0">End Date:</label>
                                        <TextField
                                            id="end-date"
                                            type="date"
                                            value={this.state.endDate.toISODate()}
                                            onChange={this.handleEndDateChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                style: { fontFamily: "'Urbanist', sans-serif" },
                                            }}
                                        />
                                    </div>
                                </div>
                                {
                                    ["sm"].includes(this.props.deviceSize) ?
                                        <></>
                                        :
                                        <div className="d-flex" style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                            <div onClick={this.handleWeekToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '4px 0 0 4px' }}>1w</div>
                                            <div onClick={this.handleMonthToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', borderTop: '1px solid lightgray', borderBottom: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>1m</div>
                                            <div onClick={this.handleYearToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '0 4px 4px 0' }}>1y</div>
                                        </div>
                                }

                            </div>
                        </div>

                    </section>

                    <section>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col">
                                    <ThemeProvider theme={this.state.BrandCreatorTable.getTheme()}>
                                        <MUIDataTable
                                            title={
                                                <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                                    <p style={{ fontSize: '22px', marginTop: "20px" }}>Brand Creators</p>
                                                    <p style={{ fontSize: '14px', marginBottom: "0" }}>Creators that created links and/or had clicks for selected date range</p>
                                                </div>
                                            }
                                            data={this.state.creators}
                                            columns={this.state.BrandCreatorTable.columns}
                                            options={this.state.BrandCreatorTable.options}
                                        />
                                    </ThemeProvider>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col">
                                    <ThemeProvider theme={this.state.BrandCreatorLinkTable.getTheme()}>
                                        <MUIDataTable
                                            title={
                                                <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                                    <p style={{ fontSize: '22px', marginTop: "20px" }}>Creator Links</p>
                                                    <p style={{ fontSize: '14px', marginBottom: "0" }}>Creator links that were created and/or had clicks over selected date range</p>
                                                </div>
                                            }                                            data={this.state.creatorLinks}
                                            columns={this.state.BrandCreatorLinkTable.columns}
                                            options={this.state.BrandCreatorLinkTable.options}
                                        />
                                    </ThemeProvider>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default BrandCreatorActivity;
